<template>
  <div class="page-container">
    <img alt="Vue logo" src="../assets/icono.png">
  </div>
</template>

<script>

export default {
  name: 'home',
}
</script>
<style>
.page-container{
	padding-top:60px;
}
</style>

